export const byLabel = (a, b)=>{
    var _ref, _ref1;
    const a_label = ((_ref = a === null || a === void 0 ? void 0 : a.label) !== null && _ref !== void 0 ? _ref : '').toLowerCase();
    const b_label = ((_ref1 = b === null || b === void 0 ? void 0 : b.label) !== null && _ref1 !== void 0 ? _ref1 : '').toLowerCase();
    return a_label === b_label ? 0 : a_label > b_label ? 1 : -1;
};
